/* eslint-disable import/no-unresolved */
import ReportConfigDetails from 'views/Rules/common/ReportConfigDetails';

const FRY9CReportConfigDetails = ({
    selectedFRY9CQuarter, setSelectedFRY9CQuarter, summaryQuartersFRY9CData, commonFRY9CData,
}) => (
    <ReportConfigDetails
        selectedQuarter={selectedFRY9CQuarter}
        setSelectedQuarter={setSelectedFRY9CQuarter}
        summaryQuartersData={summaryQuartersFRY9CData}
        commonData={commonFRY9CData}
        displayColumn="Yes"
        istopier="No"
        rule="FRY9C"
    />
);

export default FRY9CReportConfigDetails;
